// extracted by mini-css-extract-plugin
export var lightMode = "_6-0";